export const styles = {
  root: {
    boxShadow: '0',
    borderRadius: '4px',
    border: '2px solid #C1E9C2',
    '.MuiChip-root': {
      borderRadius: '4px',
      fontWeight: 500,
      '&.MuiChip-colorDefault': {
        backgroundColor: '#EEE',
        color: '#787878',
        borderColor: '#8E8E8E',
      },
      '&.MuiChip-colorError': {
        backgroundColor: '#FFEAEA',
      },
      '&.MuiChip-colorSuccess': {
        backgroundColor: '#EFFFEE',
        color: '#33C341',
        borderColor: '#33C341',
      },
      '&.MuiChip-colorWarning': {
        backgroundColor: '#FFF0DD',
        color: '#F0901E',
        borderColor: '#F0901E',
      },
      '&:not(.MuiChip-colorPrimary) .MuiChip-label': {
        paddingLeft: '16px',
        paddingRight: '16px',
      },
    },
    default: {
      border: '2px solid #EEE',
      backgroundColor: '#EEE',
      transition: 'all 1s ease-out',
    },
    dark: {
      border: '2px solid #D9D9D9',
      backgroundColor: '#D9D9D9',
    },
    success: {
      backgroundColor: '#D3F8D2',
      border: '2px solid #C1E9C2',
    },
    '&::before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 0,
      '& .Accordion-arrow': {
        transform: 'rotate(90deg)',
      },
    },
    '& .MuiAccordionSummary-root': {
      flexGrow: 2,
      padding: '0',
      '.MuiAccordionSummary-content': {
        margin: '0',
        '&.Mui-expanded': {
          margin: '0',
        },
      },
      '&.Mui-expanded': {
        minHeight: '48px',
        padding: '0',
      },
    },
    '.MuiAccordionDetails-root': {
      backgroundColor: '#FFF',
      padding: 0,
    },
    header: {
      padding: '0 6px 0 12px',
      '& .MuiTypography-root': {
        fontWeight: '500',
      },
    },
    label: {
      fontSize: '14px',
      color: '#787878',
      fontWeight: 400,
    },
    buttons: {
      padding: '0 12px',
    },
    iconArrow: {
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      color: '#787878',
      borderRadius: '4px',
      cursor: 'pointer',
      transition: '.3s all ease',
      '.Accordion-arrow': {
        transition: '.3s all ease',
      },
      '&:hover': {
        backgroundColor: '#fff',
      },
      '& > svg': {
        width: '100%',
      },
    },
  },
}
